// Copyright (c) 2020 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

// Constants
export {
  ADD_DATA_ID,
  ADD_MAP_STYLE_ID,
  AGGREGATION_TYPES,
  ALL_FIELD_TYPES,
  DATA_TABLE_ID,
  DATASET_FORMATS,
  DEFAULT_LAYER_GROUPS,
  DEFAULT_MAP_STYLES,
  DEFAULT_NOTIFICATION_TOPICS,
  DEFAULT_NOTIFICATION_TYPES,
  DELETE_DATA_ID,
  DIMENSIONS,
  EDITOR_MODES,
  EXPORT_DATA_ID,
  EXPORT_DATA_TYPE_OPTIONS,
  EXPORT_IMAGE_ID,
  EXPORT_IMG_RATIO_OPTIONS,
  EXPORT_IMG_RATIOS,
  EXPORT_IMG_RESOLUTION_OPTIONS,
  EXPORT_MAP_FORMAT_OPTIONS,
  EXPORT_MAP_FORMATS,
  EXPORT_MAP_ID,
  FIELD_OPTS,
  FILTER_TYPES,
  GEOJSON_FIELDS,
  ICON_FIELDS,
  KEPLER_GL_NAME,
  KEPLER_GL_VERSION,
  KEPLER_GL_WEBSITE,
  LAYER_BLENDINGS,
  MAX_DEFAULT_TOOLTIPS,
  PANELS,
  SIDEBAR_PANELS,
  SCALE_TYPES,
  THEME,
  TRIP_ARC_FIELDS,
  TRIP_POINT_FIELDS,
  BASE_SPEED,
  FPS,
  ANIMATION_WINDOW,
  DEFAULT_TIME_FORMAT,
  SPEED_CONTROL_RANGE,
  RESOLUTIONS
} from './default-settings';

export {BUG_REPORT_LINK, USER_GUIDE_DOC} from './user-guides';

export {VizColorPalette, DataVizColors} from './custom-color-ranges';
export {COLOR_RANGES, DEFAULT_COLOR_RANGE} from './color-ranges';
export {LAYER_TYPES} from 'layers/types';
export {PLOT_TYPES} from 'utils/filter-utils';
